import { Grid } from "@mui/material";
import CloseIconButton from "components/AppModalDialogsV2/Dialogs/lib/CloseIconButton";
import useCalculateScale from "components/PopUpManager/hooks/useCalculateScale";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { useImagePath } from "hooks";
import { clubGiftsGaloreAssets } from "assets/cdn";
import { ClubGiftsGaloreResponse } from "interfaces/club-gifts-galore-v2";
import { FeatureType } from "interfaces/feature-tracker";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { featureTrackerAPI } from "redux/apis";
import { onClosePopUp } from "redux/slices";
import { Body, Button, Container, Header, Text, Title } from "./styles";

interface CGGNewTierProps {}

export const CGGNewTier = ({}: CGGNewTierProps) => {
	const dispatch = useDispatch();
	const scale = useCalculateScale(363, 441);
	const { getImage } = useImagePath("cdn");
	const tier = clubGiftsGaloreAssets.v2.popups.tier;
	const headImageUrl = getImage(tier.background);
	const { authToken, syncUserTracker } = useWebStoreContext();
	const { reportEvent, reportPlaygamiEvent } = useGoogleAnalyticsContext();

	const { data }: { data?: ClubGiftsGaloreResponse } =
		featureTrackerAPI.endpoints.getFeatureTracker.useQueryState({
			FeatureType: FeatureType.CLUB_GIFT_BONUS_V2,
			isAuthenticated: !!authToken?.value
		});

	const onClose = () => {
		dispatch(onClosePopUp());
	};

	const { tracker } = data ?? {};
	const activeTier = tracker?.tiers[tracker?.activeTierIndex];
	const lastTier = tracker?.tiers[tracker?.tiers.length - 1];

	useEffect(() => {
		if (tracker?.tiers && tracker?.activeTierIndex) {
			reportEvent("reward_pop_up", {
				source: "club_gifts_galore",
				club_gifts_galore_id: tracker?.clubGiftId,
				progress: activeTier?.contributionCount,
				current_tier: tracker.activeTierIndex + 1,
				individual_progress:
					activeTier?.tierIndex !== undefined
						? tracker.userClubTracker.tierContributionCounts[
								activeTier.tierIndex
						  ]
						: 0,
				max_individual_contribution_limit: activeTier?.maxUserContributionCount
			});
			reportPlaygamiEvent("tp.web_frontend", {
				event_name: "reward_pop_up",
				event_type: "club_gift_galore_v2",
				action: "reward_pop_up",
				source: "club_gifts_galore",
				event_id: tracker.id,
				value_int:
					activeTier?.tierIndex !== undefined
						? tracker.userClubTracker.tierContributionCounts[
								activeTier.tierIndex
						  ]
						: 0,
				confignodecount: activeTier?.maxUserContributionCount,
				progress_status: activeTier?.contributionCount.toString(),
				loopcount: tracker.activeTierIndex + 1
			});
		}
	}, []);

	useEffect(() => {
		if (!data?.tracker?.activeTierIndex) {
			onClose();
		}
	}, [tracker]);

	if (!data?.tracker?.tiers && !data?.tracker?.activeTierIndex) {
		return null;
	}

	return (
		<Container scale={scale}>
			<Header data-image={headImageUrl}></Header>
			<CloseIconButton onClose={onClose} />
			<Body>
				<Title>
					Your Club just hit
					<br /> Tier {(activeTier?.tierIndex ?? 0) + 1}!
				</Title>
				<Text>
					{activeTier === lastTier
						? "Keep contributing to unlock the BIGGEST REWARD!"
						: `Keep contributing to unlock Tier ${
								(activeTier?.tierIndex ?? 0) + 2
						  }!`}
					<br /> Check your inbox in the game for
					<br /> your bonus prize!
				</Text>
				<Grid container spacing={2}>
					<Grid
						item
						xs={12}
						//sm={isMobile ? 6 : 12}
						display="flex"
						justifyContent="center"
					>
						<Button
							variant="contained"
							themeColor="secondary"
							sx={{
								minWidth: { xs: "80%" /* sm: isMobile ? "100%" : "80%" */ }
							}}
							onClick={() => {
								syncUserTracker();
								dispatch(onClosePopUp());
							}}
						>
							Yay!
						</Button>
					</Grid>
					{/* {isMobile && (
						<Grid item xs={12} sm={6} display="flex" justifyContent="center">
							<BackToGameButton
								source="daily_reward_dialog"
								themeColor="secondary"
								sx={{ minWidth: { xs: "80%", sm: "100%" } }}
							/>
						</Grid>
					)} */}
				</Grid>
			</Body>
		</Container>
	);
};
